import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center w-full h-full ">
      <h1 className="text-6xl font-bold text-[#0E59C6] font-pretendard leading-none">
        404
      </h1>
      <h2 className="mt-4 text-[24px] font-bold text-[#333333] font-pretendard mb-5">
        페이지를 찾을 수 없습니다.
      </h2>
      <p className="mt-2 text-[16px] text-[#939399] font-pretendard text-center leading-relaxed mb-10">
        요청하신 페이지가 존재하지 않거나, 이름이 변경되었거나,
        <br />
        일시적으로 사용할 수 없습니다.
      </p>
      <button
        onClick={() => navigate("/")}
        className=" px-8 py-3 bg-[#0E59C6] mt-10 text-white rounded-full font-bold font-pretendard hover:bg-[#0052CC] transition-colors"
      >
        홈으로 돌아가기
      </button>
    </div>
  );
}
